var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.00065C10.9173 5.00065 11.6673 5.75065 11.6673 6.66732C11.6673 7.58398 10.9173 8.33398 10.0007 8.33398C9.08398 8.33398 8.33398 7.58398 8.33398 6.66732C8.33398 5.75065 9.08398 5.00065 10.0007 5.00065ZM10.0007 13.334C12.2507 13.334 14.834 14.409 15.0007 15.0007H5.00065C5.19232 14.4007 7.75898 13.334 10.0007 13.334ZM10.0007 3.33398C8.15898 3.33398 6.66732 4.82565 6.66732 6.66732C6.66732 8.50898 8.15898 10.0007 10.0007 10.0007C11.8423 10.0007 13.334 8.50898 13.334 6.66732C13.334 4.82565 11.8423 3.33398 10.0007 3.33398ZM10.0007 11.6673C7.77565 11.6673 3.33398 12.784 3.33398 15.0007V16.6673H16.6673V15.0007C16.6673 12.784 12.2257 11.6673 10.0007 11.6673Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.39e9faadf3ffb05dc875ca550bd1d522.svg";
export { ForwardRef as ReactComponent };